import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

export const signUpFreelancer = async (signupData) => {
    try {
        const response = await apiClient.post(API_ENDPOINTS.FREELANCERS.SIGNUP, signupData);
        return response.data;
    } catch (error) {
        console.error('Freelancer signup failed:', error);
        throw error;
    }
};

export const fetchFreelancers = async () => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.FREELANCERS.ALL);
        return response.data;
    } catch (error) {
        console.error('Unable to fetch freelancers.');
    }
};

export const fetchFreelancerProfile = async (id) => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.FREELANCERS.PROFILE_VIEW(id));
        return response.data;
    } catch (error) {
        console.error(`Unable to fetch user profile for ID: ${id}`, error);
        throw error; // Re-throw the error for the caller to handle
    }
};

export const fetchFreelancerJobImages = async (freelancerId = null) => {
    try {
        // If freelancerId is an object, extract the actual value
        const id = freelancerId?.freelancerId || freelancerId;

        const response = await apiClient.get(API_ENDPOINTS.FREELANCERS.JOB_IMAGES, {
            params: id ? { freelancer_id: id } : {}, // Add freelancer_id if it's valid
        });
        return response.data;
    } catch (error) {
        console.error('Unable to fetch freelancer job images:', error);
        throw error;
    }
};

export const freelancerImageUpload = async (formData) => {
    try {
        const response = await apiClient.post(API_ENDPOINTS.FREELANCERS.IMAGE_UPLOAD, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response;
    } catch (error) {
        console.error("Error uploading freelancer image", error);
        throw error; // Re-throw the error for the caller to handle
    }
};

export const freelancerImagesUpload = async (formData) => {
    try {
        const response = await apiClient.post(API_ENDPOINTS.FREELANCERS.IMAGES_UPLOAD, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error uploading freelancer images", error);
        throw error; // Re-throw the error for the caller to handle
    }
};

export const freelancerCoverUpload = async (formData) => {
    try {
        const response = await apiClient.post(API_ENDPOINTS.FREELANCERS.COVER_UPLOAD, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response;
    }
    catch (error) {
        console.error("Error uploading freelancer image", error);
        throw error; // Re-throw the error for the caller to handle
    }
};


export const getFreelancerId = async () => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.FREELANCERS.BY_ID);
        return response.data; // Return the freelancer ID data
    } catch (error) {
        console.error('Error fetching freelancer ID:', error);
        throw error; // Re-throw for the caller to handle
    }
};

export const updateFreelancerProfile = async (updateData) => {
    try {
        const response = await apiClient.patch(API_ENDPOINTS.FREELANCERS.UPDATE_PROFILE, updateData);
        return response.data;
    } catch (error) {
        console.error('Error updating freelancer profile:', error);
        throw error;
    }
};

export const deleteFreelancerImage = async (imageId) => {
    try {
        const response = await apiClient.delete(API_ENDPOINTS.FREELANCERS.DELETE_IMAGE(imageId));
        return response.data;
    } catch (error) {
        console.error(`Error deleting freelancer image ${imageId}:`, error);
        throw error;
    }
};